@if (isLoading$ | async) {
  <app-loading></app-loading>
}
<router-outlet></router-outlet>
